import { GlobalInfo } from "@intocare/interfaces";

import * as data from "../actions/global-info";

export type State = GlobalInfo | undefined;
export const initialState: State = undefined;

export function reducer(state = initialState, action: data.Actions): State {
	switch (action.type) {
		case data.SET_ONBOARDING_INFO:
			return action.payload;
		default:
			return state;
	}
}

export const getGlobalName = (state: State) => state;
